import httpService from '@/modules/common/services/httpService';

const taxSettingsRoute = '/business/payments/v1/taxes';

const taxList = (page, perPage) => httpService.get(taxSettingsRoute, { page, per_page: perPage, new_api: true });

const createTax = (taxData) => httpService.post(taxSettingsRoute, { new_api: true, tax: taxData }).then((res) => {
  if (!res.data || !res.data.data || !res.data.data.tax) {
    throw new Error('Tax creation failed: Invalid response structure');
  }
  return res.data.data.tax;
});

export default {
  taxList,
  createTax,
};
